export default {"src":"/_next/static/media/circles.7e5d5ac6.svg","height":287,"width":350,"blurWidth":0,"blurHeight":0};